import { render, staticRenderFns } from "./customFieldModal.vue?vue&type=template&id=27742e74&scoped=true"
import script from "./customFieldModal.vue?vue&type=script&lang=js"
export * from "./customFieldModal.vue?vue&type=script&lang=js"
import style0 from "./customFieldModal.vue?vue&type=style&index=0&id=27742e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27742e74",
  null
  
)

export default component.exports